import React from 'react';

const SeventhPage = () => {
  return (
    <div className="page-section">
      <div className="container mt-4">
        <div className="row align-center">
          <div className="col-md-12 text-center title-text" style={{ maxWidth: '980px', margin: '0 auto' }}>
            NMN 30000 được sản xuất theo tiêu chuẩn dược phẩm <span className="d-none d-xl-inline"><br /></span> lý tưởng cho những ai yêu cầu chất lượng cao cấp
          </div>
        </div>
        <div className="row align-center mt-4 check-list-container">
          <div>
            <div style={{ width: '40px', height: '40px', objectFit: 'contain' }}>
              <img src="images/checklist.svg" alt="Product" className="img-fluid" loading="lazy" />
            </div>
            <div style={{ width: '100%', lineHeight: 1.1 }} className="d-flex flex-column align-items-start">
              <div style={{ fontWeight: 'bold', color: '#175ca3' }}>
                99,9% TINH KHIẾT
              </div>
              <div style={{ textAlign: 'left' }}>
                Chất lượng vượt trội, chỉ có những thành phần tinh khiết nhất
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: '40px', height: '40px', objectFit: 'contain' }}>
              <img src="images/checklist.svg" alt="Product" className="img-fluid" loading="lazy" />
            </div>
            <div style={{ width: '100%', lineHeight: 1.1 }} className="d-flex flex-column align-items-start">
              <div style={{ fontWeight: 'bold', color: '#175ca3' }}>
                HOẠT CHẤT SINH HỌC
              </div>
              <div style={{ textAlign: 'left' }}>
                Đem lại khả năng hấp thụ tối đa
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: '40px', height: '40px', objectFit: 'contain' }}>
              <img src="images/checklist.svg" alt="Product" className="img-fluid" loading="lazy" />
            </div>
            <div style={{ width: '100%', lineHeight: 1.1 }} className="d-flex flex-column align-items-start ">
              <div style={{ fontWeight: 'bold', color: '#175ca3' }}>
                KIỂM NGHIỆM LAB
              </div>
              <div style={{ textAlign: 'left' }}>
                Đảm bảo chất lượng qua kiểm nghiệm nghiêm ngặt tại các phòng thí nghiệm
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: '40px', height: '40px', objectFit: 'contain' }}>
              <img src="images/checklist.svg" alt="Product" className="img-fluid" loading="lazy" />
            </div>
            <div style={{ width: '100%', lineHeight: 1.1 }} className="d-flex flex-column align-items-start ">
              <div style={{ fontWeight: 'bold', color: '#175ca3' }}>
                TIÊU CHUẨN CHÂU ÂU
              </div>
              <div style={{ textAlign: 'left' }}>
                Sản phẩm đáp ứng tiêu chuẩn chất lượng quốc tế
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: '40px', height: '40px', objectFit: 'contain' }}>
              <img src="images/checklist.svg" alt="Product" className="img-fluid" loading="lazy" />
            </div>
            <div style={{ width: '100%', lineHeight: 1.1 }} className="d-flex flex-column align-items-start ">
              <div style={{ fontWeight: 'bold', color: '#175ca3' }}>
                CHỨNG NHẬN GMP
              </div>
              <div style={{ textAlign: 'left' }}>
                Đảm bảo quy trình sản xuất an toàn và hiệu quả
              </div>
            </div>
          </div>
          <div>
            <div style={{ width: '40px', height: '40px', objectFit: 'contain' }}>
              <img src="images/checklist.svg" alt="Product" className="img-fluid" loading="lazy" />
            </div>
            <div style={{ width: '100%', lineHeight: 1.1 }} className="d-flex flex-column align-items-start ">
              <div style={{ fontWeight: 'bold', color: '#175ca3' }}>
                XỬ LÝ DƯỢC PHẨM
              </div>
              <div style={{ textAlign: 'left' }}>
                Sản phẩm được chế biến theo quy trình dược phẩm, bảo vệ sức khỏe tối ưu
              </div>
            </div>
          </div>
        </div>
        <div className="row align-center mt-4 mb-4">
          <div className="col-md-12 text-center">
            <img src="/images/iso2.png" alt="Product" className="img-fluid" style={{  maxHeight: '100px' }} loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeventhPage;  